<template>
  <thead>
    <tr>
      <th class="rso-th rso-th--title rso-th--left">
        Наименование работ и материалы
      </th>
      <th class="rso-th rso-th--unit rso-th--left">Ед. изм</th>
      <th class="rso-th rso-th--qty rso-th--right">
        <span class="rso-th__stack">
          <span class="rso-th__stack-line rso-th__stack-line--top">Объем</span>
          <span class="rso-th__stack-line rso-th__stack-line--bottom">Кол-во</span>
        </span>
      </th>
      <th class="rso-th rso-th--norm rso-th--right">Норма расхода</th>
      <th class="rso-th rso-th--price rso-th--right">Цена</th>
      <th class="rso-th rso-th--cost rso-th--wsum rso-th--right">
        Стоимость СМР
      </th>
      <th class="rso-th rso-th--cost rso-th--msum rso-th--right">
        Материалы и оборудование
      </th>
      <th class="rso-th rso-th--cost rso-th--ttl rso-th--right">
        Стоимость всего
      </th>
    </tr>
  </thead>
</template>
